import imgLoading from '@/assets/img/loading.gif';

/**
 * @param {String} src
 */
export function createImageObject(src) {
    return {
        src: src,
        error: imgLoading,
        loading: imgLoading,
    };
}